import { makeServicesTypesFromEnum } from '@/core/container/makeServicesTypes'

enum CONSENT_SERVICES {
  ConsentAppRepository,
  ConsentAppService,
  ConsentAppResolverService,
  ConnectedAppRepository,
  ConnectedAppService,
  ConnectedAppIconRetreiverService,
}

export type ConsentServices = keyof typeof CONSENT_SERVICES

export const CONSENT_SERVICES_TYPES = makeServicesTypesFromEnum<ConsentServices>(CONSENT_SERVICES)
